
import menus from 'constants/menus'

const selectSearchMenu = (): typeof menus.search => menus.search

export default selectSearchMenu
